import { render } from "./DebugView.vue?vue&type=template&id=c8c3493c&scoped=true"
import script from "./DebugView.vue?vue&type=script&lang=js"
export * from "./DebugView.vue?vue&type=script&lang=js"

import "./DebugView.vue?vue&type=style&index=0&id=c8c3493c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8c3493c"]])

export default __exports__